module.exports = __webpack_public_path__ + "img/04.87b12457.jpg";